// extracted by mini-css-extract-plugin
module.exports = {"container":"Chart_container__LMB6B","controls":"Chart_controls__3Tt2I","header":"Chart_header___6lwZ","tabs":"Chart_tabs__3-NsJ"};